import JSCookie from 'js-cookie';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useUser } from '../store/hooks/users';
import { setAnalyticsParams } from '../store/reducers/offers';

interface IHasOffersParams {
  pageUrl: string;
  abName?: string;
}

export const useHasOffersParams = ({ pageUrl, abName }: IHasOffersParams) => {
  const dispatch = useDispatch();
  const user = useUser();

  useEffect(() => {
    if (!pageUrl) return;

    const url = new URL(pageUrl);

    // const pageUrl = window.parent.location === document.location ? document.location.search : document.referrer;
    const cookieGa = JSCookie.get('_ga')?.slice(6);
    const cookieYmUid = JSCookie.get('_ym_uid');
    const testIdVariant = JSCookie.get(abName);

    const cookieUtmz = JSCookie.get('__utmz');
    const __utmzFromParamsArray = [];

    const searchParams = new URLSearchParams(url.search);
    if (!cookieUtmz && searchParams) {
      const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

      keys.forEach((key) => {
        const value = searchParams.get(key);
        if (value) __utmzFromParamsArray.push(`${key}=${value}`);
      });
    }

    const utmParams = {
      source: 'recommendation',
      aff_sub: cookieYmUid ? `ga_${cookieGa}|ym_${cookieYmUid}` : `ga_${cookieGa}`,
      aff_sub2: url.pathname,
      aff_sub3: cookieUtmz ?? __utmzFromParamsArray.join('|'),
      ...(user && { aff_unique1: user?.sub }),
    };

    dispatch(
      setAnalyticsParams({
        utmParams,
        testIdVariant,
      }),
    );
  }, [abName, dispatch, pageUrl, user]);
};
